<template>
  <div v-if="gorunecekler.length" class="flex flex-col gap-2 mb-3 sm:mb-4">
    <div
      v-for="d in gorunecekler"
      :key="d.SistemDuyuru_rowid"
      class="flex items-center gap-3 p-3 rounded-lg border-l-4"
      :class="RENK[d.Tur] || RENK.bilgi"
    >
      <i :class="IKON[d.Tur] || IKON.bilgi" class="text-xl shrink-0"></i>
      <div class="flex-1 min-w-0">
        <span class="text-sm font-semibold">{{ d.Baslik }}</span>
        <span class="text-sm ml-2">{{ d.Metin }}</span>
      </div>
      <Button icon="pi pi-times" text aria-label="Kapat" @click="kapat(d.SistemDuyuru_rowid)" />
    </div>
  </div>
</template>

<script>
const RENK = {
  bilgi: "zemin-bilgi kenar-bilgi renk-bilgi",
  uyari: "zemin-uyari kenar-uyari renk-uyari",
  bakim: "zemin-olumsuz kenar-olumsuz renk-olumsuz",
};
const IKON = {
  bilgi: "pi pi-info-circle renk-bilgi",
  uyari: "pi pi-exclamation-triangle renk-uyari",
  bakim: "pi pi-wrench renk-olumsuz",
};
const KAPAT_ANAHTARI = "duyuruKapatilanlar";

// SK-S: aktif sistem duyurularini tenant arayuzunun ustunde gosterir. Kapatma gun+id bazli
// (sessionStorage) - LisansUyariSeridi'nin gun bazli kapatma desenini id listesine genisletir,
// cunku ayni anda birden fazla duyuru aktif olabilir.
export default {
  name: "DuyuruSeridi",
  data() {
    return {
      Liste: [],
      kapatilanlar: this._kapatilanlariOku(),
    };
  },
  computed: {
    gorunecekler() {
      return this.Liste.filter((d) => !this.kapatilanlar.includes(d.SistemDuyuru_rowid));
    },
  },
  mounted() {
    this.yukle();
  },
  methods: {
    _bugunAnahtar() {
      return new Date().toDateString();
    },
    _kapatilanlariOku() {
      try {
        const ham = JSON.parse(sessionStorage.getItem(KAPAT_ANAHTARI) || "null");
        if (ham && ham.gun === this._bugunAnahtar()) return ham.idler || [];
      } catch (e) { /* yoksay */ }
      return [];
    },
    kapat(id) {
      this.kapatilanlar.push(id);
      try {
        sessionStorage.setItem(KAPAT_ANAHTARI, JSON.stringify({ gun: this._bugunAnahtar(), idler: this.kapatilanlar }));
      } catch (e) { /* yoksay */ }
    },
    yukle() {
      this.$Servis("GET", "GetSistemDuyuruAktif", "")
        .then((res) => {
          if (res && res.status === 200 && Array.isArray(res.data)) this.Liste = res.data;
        })
        .catch(() => { /* sessiz - duyuru kritik degil */ });
    },
  },
};
</script>
